import React, { ChangeEvent } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormInput,
  CImage,
  CRow,
  CTabContent,
} from '@coreui/react-pro'
import { setAssessment, submitUpdateAssessment } from './model'
import { useAIAssessment } from './hooks'
import { useStore } from 'effector-react'
import { $userRole } from '../../../features/user'
import { role } from '../../../libs'
export const AIAssessment = () => {
  const userRole = useStore($userRole)
  const { assessment, loading } = useAIAssessment()
  const handleChange = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    let value

    if (event.currentTarget.type === 'file') {
      value = (event.currentTarget as HTMLInputElement).files![0]
    } else {
      value = event.currentTarget.value
    }

    setAssessment({
      ...assessment,
      [event.currentTarget.name]: value,
    })
  }

  return (
    <div>
      <CCard className="mb-4">
        <CCardHeader className="d-sm-flex justify-content-between align-items-center">
          <strong>Edit assessments</strong>
        </CCardHeader>
        <CCardBody>
          <CTabContent className="pt-3">
            <CForm>
              <CRow className="mb-3">
                <CCol sm={4}>
                  <CFormInput
                    type="text"
                    id="gain"
                    name="gain"
                    value={assessment.gain}
                    onChange={handleChange}
                    label="Gain"
                  />
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CCol sm={4}>
                  <CFormInput
                    type="text"
                    id="winRate"
                    name="winRate"
                    value={assessment.winRate}
                    onChange={handleChange}
                    label="Win rate"
                  />
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CCol sm={4}>
                  <CFormInput
                    type="text"
                    id="risk"
                    name="risk"
                    value={assessment.risk}
                    onChange={handleChange}
                    label="Risk"
                  />
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CCol sm={4}>
                  <CFormInput
                    type="text"
                    id="activeDays"
                    name="activeDays"
                    value={assessment.activeDays}
                    onChange={handleChange}
                    label="Active days"
                  />
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CCol sm={4}>
                  <CFormInput
                    type="text"
                    id="profit"
                    name="profit"
                    value={assessment.profit}
                    onChange={handleChange}
                    label="Profit"
                  />
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CCol sm={4}>
                  <CFormInput
                    type="text"
                    id="loss"
                    name="loss"
                    value={assessment.loss}
                    onChange={handleChange}
                    label="Loss"
                  />
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CCol sm={4}>
                  <CFormInput
                    type="text"
                    id="investors"
                    name="investors"
                    value={assessment.investors}
                    onChange={handleChange}
                    label="Investors count"
                  />
                </CCol>
              </CRow>

              <CButton
                className="mb-3"
                onClick={() => {
                  submitUpdateAssessment(assessment)
                }}
                disabled={
                  userRole != undefined &&
                  (userRole.indexOf(role.clientSupport.supportAgent()) >= 0 ||
                    userRole.indexOf(role.clientSupport.supportManager()) >= 0)
                }
              >
                Save
              </CButton>
            </CForm>
          </CTabContent>
        </CCardBody>
      </CCard>
    </div>
  )
}
